const COOKIE_PREFIX = 'KULAP.'

const set = function (key, value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  document.cookie = `${COOKIE_PREFIX}${key}=${value}; Secure;`
}

const setWithExpireTime = function (key, value, expInHrs = 12) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  const maxAge = expInHrs * 60 * 60
  document.cookie = `${COOKIE_PREFIX}${key}=${value}; max-age=${maxAge}; Secure;`
}

const get = (key) => {
  const name = `${COOKIE_PREFIX}${key}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

const remove = (name) => {
  document.cookie = `${COOKIE_PREFIX}${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT;`
}

export default {
  set,
  setWithExpireTime,
  get,
  remove
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js